<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="product_attr_list.length">
      <template v-for="attr in product_attr_list">
        <el-form-item class="attr-item" :key="attr.propertyId" :prop="attr.propertyId" :label="attr.propertyName">
          <el-select
            style="width: 100%"
            filterable
            clearable
            remote
            :remote-method="(query) => filterMethod(query, attr)"
            v-loadmore="() => loadMore(attr)"
            @focus="handleFocus(attr)"
            value-key="valueId"
            v-model="form[attr.propertyId]"
          >
            <el-option v-for="(op, opindex) in attr.displayItems" :key="op.valueId + opindex" :label="op.valueName" :value="op"></el-option>
          </el-select>
          <!-- <el-input v-else v-model="form[item.name]" clearable></el-input> -->
        </el-form-item>
      </template>
    </template>
    <div v-else>暂无属性</div>
    <div class="update-props" v-if="categoryId">
      找不到商品属性？
      <el-link :underline="false" @click="fetch_props(true)">刷新数据</el-link>
    </div>
  </el-form>
</template>

<script>
import { getXyCategoryProps } from '@/servers/prod/center/xianyu.js';
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import loadmore from '@/directives/select-load-more.js';

export default {
  directives: {
    loadmore,
  },
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      required: true,
    },
    lastLevelCateGory: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {},
      product_attr_list: [],
      rules: {},
      categoryId: '',
      fetchAttrsShopIndexs: [],
    };
  },
  computed: {
    ...mapGetters(['shops_updateIndex']),
  },
  watch: {
    lastLevelCateGory: {
      handler(v) {
        if (!v?.channelCatId) return;
        this.categoryId = v[v.length - 1];
        this.product_attr_list = [];
        this.fetchAttrsShopIndexs = []
        this.rules = {};
        this.fetch_props();
      },
      immediate: true,
      deep: true,
    },
    form: {
      deep: true,
      handler(v) {
        if (!this.product_attr_list?.length) return;
        const list = Object.values(v).map(item => {
          return {
            property_id: item.propertyId,
            property_name: item.propertyName,
            value_id: item.valueId,
            value_name: item.valueName,
          };
        }).filter(item => item.value_id);
        this.$emit('change', list);
      },
    },
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    async fetch_props(isUpdate) {
      if (!this.lastLevelCateGory.channelCatId) return;
      const { channelCatId, itemBizType, spBizType } = this.lastLevelCateGory;
      isUpdate && this.updateCatePropShopIndex('xy');
      let shopId = this.$store.getters.shops_getCategoryPropShopId('xy');
      const propConfigs = await getXyCategoryProps({
        shopId,
        channelCatId,
        itemBizType,
        spBizType,
      });
      const updateIndex = this.shops_updateIndex('xy') 
      if(!propConfigs){
        if(!this.fetchAttrsShopIndexs.includes(updateIndex)) {
            this.fetchAttrsShopIndexs.push(updateIndex)
            return this.fetch_props(true);
        } else {
          this.$message.warning('无已授权闲鱼店铺，获取类目属性信息失败，请检查店铺授权后再编辑资料！')
        }
        return;
      } 
      this.product_attr_list = propConfigs;
      this.initForm();
    },
    // 初始化类目属性数据结构
    initForm() {
      this.$set(this, 'rules', {});
      this.product_attr_list.map(attr => {
        const { propertyId, propertyName, items } = attr;
        const existingValue = this.values?.find(value => value.property_id === propertyId);
        items.forEach(item => {
          item.propertyId = propertyId
          item.propertyName = propertyName
        });
        if (existingValue && !items.some(op => op.valueId === existingValue.value_id)) {
          existingValue.valueId = '';
          existingValue.valueName = '';
        }
        this.setRulesByPropConfig(attr);
        const _value = {
          valueId: existingValue?.value_id || '',
          valueName: existingValue?.value_name || '',
          propertyId,
          propertyName,
        };
        this.$set(this.form, propertyId, _value);

        // 优化大数据量渲染
        const PAGE_SIZE = 20;
        this.$set(attr, 'allOptions', items);
        this.$set(attr, 'filteredOptions', items);
        this.$set(attr, 'page', 1);
        let initialDisplay = items.slice(0, PAGE_SIZE);
        if (_value.valueId) {
          const selected = items.find(i => i.valueId === _value.valueId);
          if (selected && !initialDisplay.some(i => i.valueId === selected.valueId)) {
            initialDisplay.unshift(selected);
          }
        }
        this.$set(attr, 'displayItems', initialDisplay);
      });
    },
    loadMore(attr) {
      const PAGE_SIZE = 20;
      const { filteredOptions, page } = attr;
      if (!filteredOptions) return;
      const start = page * PAGE_SIZE;
      if (start >= filteredOptions.length) return;

      const nextItems = filteredOptions.slice(start, start + PAGE_SIZE);
      attr.displayItems.push(...nextItems);
      attr.page += 1;
    },
    filterMethod(query, attr) {
      if (attr.timer) clearTimeout(attr.timer);
      attr.timer = setTimeout(() => {
        let filtered = attr.allOptions;
        if (query) {
          const lowerQuery = query.toLowerCase();
          filtered = attr.allOptions.filter(item => 
            item.valueName && item.valueName.toLowerCase().includes(lowerQuery)
          );
        }
        attr.filteredOptions = filtered;
        attr.page = 1;
        const PAGE_SIZE = 20;
        let display = filtered.slice(0, PAGE_SIZE);
        
        // 如果是空搜索，且有选中值，确保选中值在列表中
        if (!query && this.form[attr.propertyId]?.valueId) {
          const selected = attr.allOptions.find(i => i.valueId === this.form[attr.propertyId].valueId);
          if (selected && !display.some(i => i.valueId === selected.valueId)) {
            display.unshift(selected);
          }
        }
        attr.displayItems = display;
      }, 300);
    },
    handleFocus(attr) {
      // 聚焦时重置搜索结果
      this.filterMethod('', attr);
    },
    setRulesByPropConfig(config) {
      let rules = [];
      const { required, propertyId, propertyName } = config;
      rules.push({ required: !!required, message: `请完善${propertyName}` });
      this.$set(this.rules, propertyId, rules);
    },
  },
};
</script>

<style lang="scss" scoped>
.category-attr {
  // align-items: flex-start;
  position: relative;

  ::v-deep .el-form-item__label {
    padding: 0;
  }
  .update-props {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
}
</style>